import React from "react";

interface Props {}

export const ProfileSubscriptionList: React.FC<Props> = () => {
  return <div></div>;
};
